import moment from "moment";
import React from "react";
import { Image } from "react-bootstrap";
import ViewTransactionModal from "../superAdminUserWallatTransactions/ViewTransactionModal";
function TableHeadScan(props) {
  return (
    <tr>
      <th style={{ width: "10%" }}>
        <div className="f12-400">
          Transaction <br />
          ID
        </div>
      </th>
      <th style={{ width: "10%" }}>
        <div className="f12-400">
          Business Name
          <br />
          /Location
        </div>
      </th>
      <th style={{ width: "15%" }}>
        <div className="f12-400">User Name</div>
      </th>
      <th style={{ width: "15%" }}>
        <div className="f12-400">
          Source Request Type/ <br />
          Transaction ID
        </div>
      </th>
      <th style={{ width: "10%" }}>
        <div className="f12-400">Payment Status</div>
      </th>
      <th style={{ width: "15%" }}>
        <div className="f12-400">Date & Time</div>
      </th>
      <th style={{ width: "10%" }}>
        <div className="f12-400">Amount</div>
      </th>
    </tr>
  );
}

export default TableHeadScan;

export const TableBodyScan = (props) => {
  const data = props.data;
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className="sd_body_table-row"
                // style={{ textAlign: "center" }}
              >
                <td style={{ width: "10%", paddingLeft: "1.75rem" }}>
                  <div className="f12-500">
                    {data?.transactionNumber || data?._id}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="d-flex align-items-center">
                    <div className="super-admin-suggestion-table-body-boxone">
                      {/* <div className="super-admin-suggestion-imageBoxOne enIMG33">
                        <Image
                          fluid
                          src={
                            data?.restaurant_id?.logo_url
                              ? data?.restaurant_id?.logo_url
                              : require("../../../../assets/images/ActionImages/demoprofile.jpg")
                          }
                          alt="Icon"
                          className="rounded-circle"
                        />
                      </div> */}
                    </div>
                    <div className="super-admin-suggestion-imageBoxTwo ml-2">
                      <div className="f12-500">
                        {data?.restaurant_id?.restaurant_name} <br />
                        {data?.restaurant_id?.area}
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }} className="text-center">
                  <div className="d-flex align-items-center">
                    <div className="super-admin-suggestion-imageBoxTwo ml-2">
                      <div className="f12-500">
                        {data?.user_id?.first_name || ""}{" "}
                        {data?.user_id?.last_name || ""}
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <div className="f12-500 text-break">
                    Scan & Pay
                    <br />
                    {data?.razorpay_order_details?.receipt || ""}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {/* enSuccessLBL */}
                    {data?.status === "captured" ? (
                      <div className="badge badge-success">Success</div>
                    ) : (
                      <div className="badge badge-warning">Pending</div>
                    )}
                  </div>
                </td>

                <td style={{ width: "15%" }}>
                  <div className="f12-500">
                    {moment(data?.createdAt).format("ll")}
                    <br />
                    {moment(data?.createdAt).format("LT")}
                  </div>
                </td>
                <td style={{ width: "5%" }}>
                  <div className="f12-500">₹ {data?.amount}</div>
                </td>
                <td style={{ width: "5%" }}>
                  <ViewTransactionModal
                    data={data}
                    scan_and_pay={{
                      type: "Scan & Pay",
                      _id: data?.razorpay_order_details?.receipt,
                    }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
